<template>


            <v-expand-transition>
                <v-card
                        class=""
                        width="550"
                        v-show="active"
                        height="480"
                        style="margin-top:40px;margin-left:40px;"
                        :img="require('../assets/KoN_smoke.png')"
                >
                    <v-fab-transition>
                        <v-img
                                class="mx-auto my-auto"
                                style="top:80px;"
                                height="300"
                                width="300"
                                contain
                                v-if="stage===1"

                                :src="require('../assets/KoN.png')"
                        >

                        </v-img>
                    </v-fab-transition>

                    <v-card-text style="text-align: center;" v-if="stage===3">
                        <v-img
                                class=""
                                style="top:-70px;left:185px;z-index: 2;"
                                height="150"
                                width="150"
                                contain


                                :src="require('../assets/KoN.png')"
                        >

                        </v-img>

                        <v-img
                                class=""
                                style="left: 8px; top: -135px;-webkit-box-shadow: 0px 0px 12px 0px rgb(0 0 0); -moz-box-shadow: 0px 0px 12px 0px rgba(247,176,69,1); box-shadow: 0px 0px 12px 0px rgb(0 0 0);mix-blend-mode: screen;"
                                height="320"
                                width="500"
                                contain


                                :src=map_image
                        >
                            <v-list dense subheader style="background:transparent;">

                                <v-list-item

                                >

                                    <v-chip   class="ma-2" style="opacity:0.3;" text-color="white" color="orange"   v-if="votes.length>2" > <b>{{votes[votes.length-3][0]}} </b> <span style="margin-left:6px;">  {{votes[votes.length-3][1]}}  </span> </v-chip>

                                </v-list-item>
                                <v-list-item

                                >

                                    <v-chip   class="ma-2" style="opacity:0.6;" text-color="white" color="orange" v-if="votes.length>1" > <b>{{votes[votes.length-2][0]}} </b> <span style="margin-left:6px;">  {{votes[votes.length-2][1]}}  </span> </v-chip>

                                </v-list-item>
                                <v-list-item

                                >
                                    <v-chip :class="showlatestVote ? 'shake_me':''" class="ma-2" text-color="white" color="orange"   v-if="votes.length>0"> <b>{{votes[votes.length-1][0]}} </b><span style="margin-left:6px;">  {{votes[votes.length-1][1]}}</span> </v-chip>

                                </v-list-item>
                            </v-list>


                        </v-img>

                        <v-slide-x-transition>
                            <h1 v-show="show_vad_heter_spoten" style="color:white;text-shadow: rgb(29 18 88) 1px 1px 13px;margin-top:-110px;" class="display-2">
                                Vad kallas spoten?
                            </h1>
                        </v-slide-x-transition>
                        <v-slide-x-transition>
                            <h1 v-show="show_gissa_med" style="color:white;;text-shadow: rgb(29 18 88) 1px 1px 13px;margin-top:-110px;" class="display-2">
                                !<span style="color:orange;text-shadow: rgb(255 165 0) 1px 1px 13px;">ditt svar</span><br> <span style="top: -20px !important; position: relative;font-size:20px;">i chatten</span>
                            </h1>
                        </v-slide-x-transition>
                    </v-card-text>
                    <v-card-text v-if="stage===4">
                        <v-img
                                class=""
                                style="top:-70px;left:185px;z-index: 2;"
                                height="150"
                                width="150"
                                contain


                                :src="require('../assets/KoN.png')"
                        >

                        </v-img>

                        <v-row style="width:100%;height:100%;margin-top: -50px;" class="mx-0" align="center" justify="center">
                            <v-col cols="12">
                                <v-list subheader style="background:transparent;">

                                    <v-list-item
                                            class="pa-2"

                                    >
                                        <v-spacer></v-spacer>
                                        <v-chip style="background-image: linear-gradient(315deg, rgb(234 147 19) 0%, rgb(232, 188, 133) 74%)" dark color="orange" large v-if="winners.length>0">
                                            <v-avatar
                                                    left
                                                    style="background-image: linear-gradient(315deg, rgb(234 147 19) 0%, rgb(232, 188, 133) 74%)"
                                            >
                                                <b>1</b>
                                            </v-avatar>
                                            <b>{{winners[0]}}</b>
                                        </v-chip>
                                        <v-spacer></v-spacer>


                                    </v-list-item>
                                    <v-list-item
                                            class="pa-2"

                                    >
                                        <v-spacer></v-spacer>
                                        <v-chip dark color="gray" style="background-color: #bdd4e7; background-image: linear-gradient(315deg, #bdd4e7 0%, #8693ab 74%);" large v-if="winners.length>1">
                                            <v-avatar
                                                    left
                                                    class="gray darken-4"
                                            >
                                                <b>2</b>
                                            </v-avatar>
                                            <b>{{winners[1]}}</b>
                                        </v-chip>
                                        <v-spacer></v-spacer>


                                    </v-list-item>
                                    <v-list-item
                                            class="pa-2"

                                    >
                                        <v-spacer></v-spacer>
                                        <v-chip dark style="background-color: #772f1a; background-image: linear-gradient(315deg, #772f1a 0%, #f2a65a 74%);" color="orange" large v-if="winners.length>2">
                                            <v-avatar
                                                    left
                                                    style="background-color: #772f1a; background-image: linear-gradient(315deg, #772f1a 0%, #f2a65a 74%);"
                                            >
                                                <b>3</b>
                                            </v-avatar>
                                            <b>{{winners[2]}}</b>
                                        </v-chip>
                                        <v-spacer></v-spacer>


                                    </v-list-item>
                                </v-list>

                            </v-col>

                            <v-col cols="12" align="center">
                                <h1 v-if="maps[map_counter]" style="color:white;text-shadow: rgb(29 18 88) 1px 1px 13px;" >
                                    Rätt svar: <i>{{maps[map_counter].answer[0]}}!</i>
                                </h1>
                            </v-col>

                            <v-col v-if="maps[map_counter].answer.length>1" cols="12" align="center">
                                <h3 style="color:white;text-shadow: rgb(29 18 88) 1px 1px 13px;">
                                    också godkänt: <i v-if="maps[map_counter].answer.length>1">{{maps[map_counter].answer[1]}}</i><i v-if="maps[map_counter].answer.length>2">, {{maps[map_counter].answer[2]}}</i><i v-if="maps[map_counter].answer.length>3">, {{maps[map_counter].answer[3]}}</i>
                                </h3>
                            </v-col>

                        </v-row>

                    </v-card-text>
                    <v-card-text v-if="stage===5 && winners.length>0">
                            <v-img
                                    class=""
                                    style="top:-70px;left:185px;z-index: 2;"
                                    height="150"
                                    width="150"
                                    contain


                                    :src="require('../assets/KoN.png')"
                            >

                            </v-img>


                        <v-row style="width:100%;height:100%;margin-top: -50px;" class="mx-0" align="center" justify="center">
                            <v-col cols="12" align="center">
                                <h2  style="color:white;text-shadow: rgb(29 18 88) 1px 1px 13px;" >
                                    Ni kan ju det här ✌
                                </h2>
                            </v-col>
                            <v-col cols="12" align="center" style="margin-top: 30px;">
                                <h1  style="color:white;text-shadow: rgb(29 18 88) 1px 1px 13px;line-height: 30px;" >
                                    Anmäl ditt lag till Nordens<br> största esport-turnering i CS:GO
                                </h1>
                            </v-col>
                            <v-col>
                                <div class="text-center">
                                    <v-chip color="orange" dark class="ma-2">
                                        <b>vinstpengar</b>
                                    </v-chip>
                                    <v-chip color="orange" dark class="ma-2">
                                        <b>produktpriser</b>
                                    </v-chip>
                                    <v-chip color="orange" dark class="ma-2">
                                        <b>öppet för alla</b>
                                    </v-chip>
                                    <v-chip color="orange" dark class="ma-2">
                                        <b>tittartävlingar</b>
                                    </v-chip>
                                    <v-chip color="orange" dark class="ma-2">
                                        <b>128 platser</b>
                                    </v-chip>

                                </div>
                            </v-col>

                        </v-row>
                        <v-card-actions>
                            <v-card-subtitle style="color:white;width:100%;text-align: right;"><span>Se länken i chatten!</span></v-card-subtitle>
                        </v-card-actions>

                    </v-card-text>



                </v-card>
            </v-expand-transition>


</template>

<script>
    export default {
        name: "SponsKing",
        data() {
            return {
                active:false,
                stage:1,
                show_vad_heter_spoten:false,
                show_gissa_med:false,
                showlatestVote:false,
                showlatestVoteTimer:null,
                votes:[],
                votees:[],
                map_counter:0,
                winners:[],
                maps:[
                    {img:"palace.png",answer:["palace"]},
                    {img:"pit.png",answer:["pit"]},
                    {img:"bench.png",answer:["bench","f0rest","forest"]},
                    {img:"library.png",answer:["library","lib"]},
                    {img:"boiler.png",answer:["boiler"]},
                    {img:"ticket.png",answer:["ticket"]},
                    {img:"dragon.png",answer:["dragon"]},
                    {img:"graveyard.png",answer:["graveyard","grave yard","gy"]},
                    {img:"tetris.png",answer:["tetris"]},
                    {img:"catwalk.png",answer:["catwalk","cat walk","cat","cw"]},
                    {img:"forklift.png",answer:["forklift","fork lift","fork","truck"]},
                    {img:"secret.png",answer:["secret"]},
                    {img:"ivy.png",answer:["ivy"]},
                    {img:"nbk.png",answer:["nbk"]},
                    {img:"suicide.png",answer:["suicide"]},
                    {img:"banana.png",answer:["banana"]},
                    {img:"kitchen.png",answer:["kitchen","market"]}
                    ]

            }
        },
        mounted:function(){
            let u=this.$route.query.u;
            this.$socket.emit('spons_listen_king',u);





        },

        computed: {
            map_image:function(){
                return require(`../assets/kon/${this.maps[this.map_counter].img}`);
            }
        },

        sockets: {


            show_king:function(){
                this.resetAll();
                this.go();

            },
            vote:function([message,user]){
                this.showlatestVote=true;
                let self=this;
                let guess=message;
                setTimeout(function(){
                    self.showlatestVote=false;
                },1000);
                this.votes.push([user,guess]);
                if(this.maps[this.map_counter].answer.includes(guess.toLowerCase()) && !this.winners.includes(user)){
                    this.winners.push(user)
                }
                if(!this.votees.includes(user)){
                    this.votees.push(user)
                }


            },
            connected:function(){
            }
        },
        methods:{
            resetAll:function(){

                this.stage=1;
                this.show_vad_heter_spoten=false;
                this.show_gissa_med=false;
                this.showlatestVote=false;
                this.showlatestVoteTimer=null;
                this.votes=[];
                this.winners=[];
            },

            go:function(){
                this.map_counter+=1;
                this.map_counter=this.map_counter % (this.maps.length-1)
                let self=this;
                setTimeout(function(){
                    self.active=true;

                },250);
                setTimeout(function(){
                    self.stage=2;
                },1250);
                setTimeout(function(){
                    self.stage=3;
                    self.show_vad_heter_spoten=true;
                },1650);

                setTimeout(function(){
                    self.show_vad_heter_spoten=false;

                },4000);
                setTimeout(function(){
                    self.show_gissa_med=true;
                },4300);
                setTimeout(function(){
                    self.show_gissa_med=false
                },8000);
                setTimeout(function(){
                    self.show_vad_heter_spoten=true;
                },8300);
                setTimeout(function(){
                    self.show_vad_heter_spoten=false;
                },12000);
                setTimeout(function(){
                    self.show_gissa_med=true;
                },12300);
                setTimeout(function(){
                    self.stage=4
                },24000);
                setTimeout(function(){
                    self.stage=5
                },30000);
                setTimeout(function(){
                    self.active=false;
                    self.$socket.emit('bye_spons_king',[self.votes.length,self.votees.length,self.winners.length]);
                    self.resetAll();
                },35000);

            }


        }
    }
</script>

<style>
    iframe{
        width:100% !important;
        height:100% !important;
    }
    ::-webkit-scrollbar {
        width: 0 !important;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: transparent !important;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: transparent !important;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background:transparent !important;
    }
    @keyframes MOVE-BG {

        from {
            -webkit-transform: translateX(-200px);
            -moz-transform: translateX(-200px);
            -ms-transform: translateX(-200px);
            -o-transform: translateX(-200px);
            transform: translateX(-200px);

        }
        to {

            -webkit-transform: translateX(-350px);
            -moz-transform: translateX(-350px);
            -ms-transform: translateX(-350px);
            -o-transform: translateX(-350px);
            transform: translateX(-350px);

        }
    }
    .move_bg{
        animation-name: MOVE-BG;
        animation-duration: 30s;
        animation-timing-function: ease-in-out;
        animation-iteration-count: 1;
        -webkit-animation-fill-mode: forwards;
    }

    .hidden {
        visibility: hidden;
        opacity: 0;
        transition: visibility 0s 2s, opacity 2s linear;
    }
    .visible {
        visibility: visible;
        opacity: 1;
    }

    .shake_me{
        animation: shake 0.3s;
    }

    @keyframes shake {
        0% { transform: translate(1px, 1px) rotate(0deg); }
        10% { transform: translate(-1px, -2px) rotate(-1deg); }
        20% { transform: translate(-3px, 0px) rotate(1deg); }
        30% { transform: translate(3px, 2px) rotate(0deg); }
        40% { transform: translate(1px, -1px) rotate(1deg); }
        50% { transform: translate(-1px, 2px) rotate(-1deg); }
        60% { transform: translate(-3px, 1px) rotate(0deg); }
        70% { transform: translate(3px, 1px) rotate(-1deg); }
        80% { transform: translate(-1px, -1px) rotate(1deg); }
        90% { transform: translate(1px, 2px) rotate(0deg); }
        100% { transform: translate(1px, -2px) rotate(-1deg); }
    }

</style>
